/**
 * Clamp inspection label serials are usually digits with a leading YYYYMM batch prefix.
 * Keep in sync with `src/hub/clampqc-serial-ym-prefix.ts` (UI cannot import from integrator src).
 */

export type ClampQcSerialYmPrefix = {
  year: number;
  month: number;
};

export function parseClampInspectionSerialYmPrefix(trimmedSerial: string): ClampQcSerialYmPrefix | null {
  const digits = trimmedSerial.trim();
  if (!/^\d+$/.test(digits) || digits.length < 6) {
    return null;
  }
  const year = Number.parseInt(digits.slice(0, 4), 10);
  const month = Number.parseInt(digits.slice(4, 6), 10);
  if (!Number.isFinite(year) || !Number.isFinite(month) || month < 1 || month > 12) {
    return null;
  }
  return { year, month };
}

export function clampQcSerialYmPrefixesDiffer(previousSerial: string, currentSerial: string): boolean {
  const previousPrefix = parseClampInspectionSerialYmPrefix(previousSerial);
  const currentPrefix = parseClampInspectionSerialYmPrefix(currentSerial);
  if (previousPrefix === null || currentPrefix === null) {
    return false;
  }
  return previousPrefix.year !== currentPrefix.year || previousPrefix.month !== currentPrefix.month;
}

export function clampQcSerialYmBatchLabel(serial: string): string | null {
  const prefix = parseClampInspectionSerialYmPrefix(serial);
  return prefix === null ? null : formatClampQcSerialYmPrefixLabel(prefix);
}

export function formatClampQcSerialYmPrefixLabel(prefix: ClampQcSerialYmPrefix): string {
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  return `${monthNames[prefix.month - 1] ?? String(prefix.month)} ${String(prefix.year)}`;
}
